<template>
  <div class="bg">
    <div class="user-info-box">

      <div class="user-profile" v-show="student">
        <item-user-profile item-name="姓名" :item-content="student.name"></item-user-profile>
        <item-user-profile item-name="性别" :item-content="student.sex"></item-user-profile>
        <item-user-profile item-name="生日" :item-content="student.birthday"></item-user-profile>
        <!-- <item-user-profile item-name="缴费日期" :item-content="student.created_at"></item-user-profile> -->
        <item-user-profile item-name="课次" :item-content="student.courseSummary"></item-user-profile>
        <!-- <item-user-profile item-name="学校" :item-content="student.campusName"></item-user-profile> -->
        <!-- <item-user-profile item-name="班级" :item-content="student.grade_name"></item-user-profile> -->
      </div>
    </div>
    <div class="title">
    </div>
    <div class="back-box">
      <v-go-back-btn></v-go-back-btn>
    </div>


  </div>
</template>

<script>
  import ItemUserProfile from '../components/ItemUserProfile.vue';
  import VGoBackBtn from '../components/VGoBackBtn.vue';
  import Teacher from '../api/teacher';
  export default{
    name: 'student-profile-info',
    data() {
      return {
        student: {}
      };
    },
    deactivated() {
      this.$destroy();
    },
    created() {
      //调查询学生个人信息接口
      this.getProfile();
    },
    components: {
      ItemUserProfile, VGoBackBtn
    },
    methods: {
      getProfile() {
        Teacher.getStudentProfileInfo(this.$route.query).then(response => {
            response.rows[0].sex=response.rows[0].sex=='0' ? '男':'女';
            this.student = response.rows[0];
        }).catch(e => {
          console.log(e);
        });
      }
    },
    computed: {
      // birthday() {
      //   return this.student.birth ? new Date(this.student.birth * 1000).Format('yyyy-MM-dd') : '';
      // },
      // paymentDate() {
      //   return this.student.created_at ? new Date(this.student.created_at * 1000).Format('yyyy-MM-dd') : '';
      // },
      // courseInfo() {
      //   return this.student.surplus_course ? (`${this.student.surplus_course}/${this.student.total_course}`) : '';
      // }
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../assets/scss/base.scss';

  .bg {
    width: 100%;
    background-color: #e7c792;
    .user-info-box {
      position: absolute;
      box-sizing: border-box;
      width: px2rem(650);
      left: px2rem(50);
      top: px2rem(128);
      bottom: px2rem(180);
      background-color: #fff6d8;
      border-radius: px2rem(8);
      padding: px2rem(105) px2rem(43) 0 px2rem(43);
      font-size: px2rem(30);
      color: #4f4f4f;
    }

    .title {
      position: absolute;
      top: px2rem(74);
      left: px2rem(160);
      height: px2rem(110);
      width: px2rem(430);
      @include bg-img('../assets/img/teacher/details');
    }

    .back-box {
      position: absolute;
      bottom: px2rem(60);
    }
  }
</style>



// WEBPACK FOOTER //
// StudentProfileInfo.vue?19462ac6